// import { Button } from "bootstrap";
// import { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { Unity, useUnityContext } from "react-unity-webgl";

// export default function CannonGame() {
//     const gameData = useSelector(state => state?.game?.gameData);
//     const [canHit, setCanHit] = useState(true);
//     const [lotteryBucketIndex, setLotteryBucketIndex] = useState(0);
//     const [shouldShowGame, setShouldShowGame] = useState(false);
//     const { unityProvider, isLoaded, loadingProgression, initialisationError, sendMessage } = useUnityContext({
//         loaderUrl: "game-build/buid.loader.js",
//         dataUrl: "game-build/buid.data.br",
//         frameworkUrl: "game-build/buid.framework.js.br",
//         codeUrl: "game-build/buid.wasm.br",
//     });

//     useEffect(() => {
//         // is portrait mode
//         if (window.innerWidth > window.innerHeight * 1.4) {
//             setShouldShowGame(true);
//         } else {
//             setShouldShowGame(false);
//         }
//     }, [lotteryBucketIndex])

//     // return unity game in canvas
//     return (
//         <>
//             {!isLoaded && <div>game is loading... {loadingProgression}, {initialisationError}</div>}
//             {!isLoaded && <Unity unityProvider={unityProvider} />}
//             <div
//                 style={{
//                     position: "absolute",
//                     top: "70%",
//                     left: "50%",
//                     transform: "translate(-50%,-50%)"
//                 }}
//             >
//                 {/* <Button onClick={() => {
//                     if (canHit) {
//                         setCanHit(false)
//                         const randomIndex = Math.floor(Math.random() * 5);
//                         setLotteryBucketIndex(randomIndex)
//                         // eslint-disable-next-line no-undef
//                         unityInstance.SendMessage('CannonGame', 'HitBucket', randomIndex);
//                     }
//                 }}>Hit</Button> */}
//             </div>
//         </>)
// }


import React, { useState, useEffect } from 'react';
import WinPriceModal from '../win-price-modal/WinPriceModal';
import BallsGameInstruction from '../balls-game-instruction/BallsGameInstruction';
import BallsGamePasscode from '../balls-game-passcode/BallsGamePasscode';
import { axios_updateVoucherStatus } from '../../apiConnections/voucherApi';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const CannonGame = () => {
    const { voucher_id } = useParams();
    const gameData = useSelector((state) => state?.game?.gameData)

    const [currentStep, setCurrentStep] = useState("instruction") //instruction, passcode, game
    const [isBackgroundAudioPlaying, setIsBackgroundAudioPlaying] = useState(false);

    const [unityInstance, setUnityInstance] = useState(null);
    const [canHit, setCanHit] = useState(true);
    const [isWinPriceModalOpen, setIsWinPriceModalOpen] = useState(false);
    const [hitWinner, setHitWinner] = useState(false);
    const [playedTimes, setPlayedTimes] = useState(1);
    const [isFireButtonVisible, setIsFireButtonVisible] = useState(false);
    const [loadingProgression, setLoadingProgression] = useState(0);

    const ballCollided = () => {
        console.log('hit bucket');
        if (!hitWinner) {
            unityInstance.SendMessage('background', 'PlayAww');
            setCanHit(true);
            return;
        }
        // won!!!
        unityInstance.SendMessage('GameSquare', 'BurstConfetti');
        unityInstance.SendMessage('background', 'PlayYay');
        const updateStatusReq = {
            voucher_id: voucher_id,
            status: 3 // game won
        }
        axios_updateVoucherStatus(updateStatusReq)
        setTimeout(() => {
            setIsWinPriceModalOpen(true);
        }, 800);
    }
    window.ballCollided = ballCollided;

    useEffect(() => {
        // Create script element to load Unity game
        let script;
        if (currentStep === "game") {
            script = document.createElement('script');
            script.src = '/game-build/build.loader.js';
            script.onload = () => {
                console.log('Unity game has loaded!');
                const canvas = document.querySelector('#gameCanvas');
                window.createUnityInstance(canvas, {
                    dataUrl: "/game-build/build.data",
                    frameworkUrl: "/game-build/build.framework.js",
                    codeUrl: "/game-build/build.wasm",
                    // loader
                }, (progress) => {
                    setLoadingProgression(progress * (10 / 9));
                }
                ).then((unityInstance) => {
                    setUnityInstance(unityInstance);
                    // unityInstance.SetFullscreen();
                    setLoadingProgression(1);
                    setTimeout(() => {
                        setIsFireButtonVisible(true)
                    }, 3000);
                }).catch((message) => {
                    alert(message);
                });

            };
            document.body.appendChild(script);
        }

        return () => {
            if (script) {
                document.body.removeChild(script);
            }
        };
    }, [
        currentStep
    ]);

    return (
        <>
            <div
                style={{
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100vh",
                    // backgroundImage: `url(/images/bg-grad.png)`,
                    // backgroundColor: "#000",
                    // backgroundSize: "contain",
                    background: "radial-gradient(circle, rgba(82,116,148,1) 0%, rgba(0,39,75,1) 100%)"

                }}
            >
                <div
                    style={{
                        position: "absolute",
                        color: "#fff",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%,-50%)",
                        visibility: currentStep === "game" ? loadingProgression === 1 ? "hidden" : "visible" : "hidden",
                    }}
                >
                    Loading Game... {`${(loadingProgression > 0) ? ((loadingProgression * 100).toFixed(2) + "%") : ""}`}
                </div>
                <div
                    style={{
                        visibility: currentStep === "game" ? "visible" : "hidden",
                        position: "absolute",
                        zIndex: currentStep === "game" ? 1 : -1,
                    }}
                >
                    <canvas
                        id="gameCanvas"
                        style={{ width: '100vw', height: '100vh', visibility: isFireButtonVisible ? "visible" : "hidden" }}
                    >
                    </canvas>
                    {isFireButtonVisible && <button
                        onClick={() => {
                            let winner = "l3";
                            let loosers = ["0", "r3", "l2"]
                            let tohit;
                            setPlayedTimes(playedTimes + 1);
                            if (playedTimes > 2) {
                                setHitWinner(true);
                                tohit = winner;
                            } else {
                                tohit = loosers[Math.floor(Math.random() * loosers.length)];
                            }
                            unityInstance.SendMessage('background', 'FireBall', tohit);
                            setCanHit(false);
                        }}
                        className='primary-button'
                        style={{
                            position: "fixed",
                            top: "90%",
                            left: "50%",
                            transform: "translate(-50%,-50%)",

                        }}
                        disabled={!canHit}
                    >
                        Throw
                    </button>}
                </div>



                {currentStep === "instruction" &&
                    <div className='text-center' style={{
                        overflowY: "auto",
                        height: "100dvh",
                    }}>
                        <BallsGameInstruction setCurrentStep={setCurrentStep} setIsBackgroundAudioPlaying={setIsBackgroundAudioPlaying} />
                    </div>
                }

                {currentStep === "passcode" &&
                    <div className='text-center'>
                        <BallsGamePasscode setCurrentStep={setCurrentStep} />
                    </div>
                }
            </div>
            <WinPriceModal isOpen={isWinPriceModalOpen} setIsOpen={setIsWinPriceModalOpen} prizeMessage={gameData?.game?.win_msg} />
        </>
    );
};

export default CannonGame;
